export const SET_INITIAL_DATA = 'SET_INITIAL_DATA'
export const GET_INITIAL_DATA = 'GET_INITIAL_DATA'
export const DELETE_INVOICE = 'DELETE_INVOICE'
export const UPDATE_INVOICE_STATUS = 'UPDATE_INVOICE_STATUS'
export const DELETE_ESTIMATE = 'DELETE_ESTIMATE'
export const UPDATE_ESTIMATE_STATUS = 'UPDATE_ESTIMATE_STATUS'
export const SET_INVOICE_GROUP_COUNT = 'SET_INVOICE_GROUP_COUNT'
export const SET_FUNDER_CREDIT_LIMIT_DATA = 'SET_FUNDER_CREDIT_LIMIT_DATA'
